module.exports = __webpack_public_path__ + "static/media/order-login.baf71d0f.svg";